import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_batch_update",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "batch_update",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_batch_update_button",
  "data-kt-drawer-close": "#kt_drawer_batch_update_close",
  "data-kt-drawer-width": "70.5vw"
}
const _hoisted_2 = {
  id: "kt_batch_update",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light rounded-0\" id=\"kt_batch_update_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Batch Update </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_batch_update_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_batch_update_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_batch_update_body",
  "data-kt-scroll-dependencies": "#kt_batch_update_header, #kt_batch_update_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_6 = { class: "card-body p-2" }
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_batch_update_scroll"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Batch Number", -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Custom Batch Number", -1)
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Location", -1)
const _hoisted_15 = { class: "row mt-4" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Capacity", -1)
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Start Date", -1)
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "End Date", -1)
const _hoisted_22 = { class: "card my-5 mb-xl-10" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#batch_detail",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Term Details")
  ])
], -1)
const _hoisted_24 = {
  id: "batch_detail",
  class: "collapse show"
}
const _hoisted_25 = { class: "collapse show" }
const _hoisted_26 = { class: "card-body border-top pt-7 p-9" }
const _hoisted_27 = { class: "form-group mb-4" }
const _hoisted_28 = { class: "btn-sm badge-primary mr-4" }
const _hoisted_29 = { class: "btn-sm badge-secondary mr-4" }
const _hoisted_30 = { class: "btn-sm badge-info mr-4" }
const _hoisted_31 = { class: "btn-sm badge-success mr-4" }
const _hoisted_32 = { class: "btn-sm badge-primary mr-4" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "row mt-4" }
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Start Date ", -1)
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "End Date ", -1)
const _hoisted_40 = { class: "table-responsive" }
const _hoisted_41 = { class: "table table-row-dashed table-row-gray-600 align-middle gs-0 gy-4" }
const _hoisted_42 = { class: "fw-bolder text-dark" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, "Day", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Training Room", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Start Time", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "End Time", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-60px" }, "Duration(H)", -1)
const _hoisted_48 = {
  key: 0,
  class: "min-w-130px"
}
const _hoisted_49 = {
  key: 1,
  class: "min-w-130x"
}
const _hoisted_50 = { class: "col-md-2" }
const _hoisted_51 = { class: "col-md-2" }
const _hoisted_52 = { class: "col-md-1" }
const _hoisted_53 = ["name", "onUpdate:modelValue", "onBlur"]
const _hoisted_54 = { class: "col-md-1" }
const _hoisted_55 = ["name", "onUpdate:modelValue", "onBlur"]
const _hoisted_56 = { class: "col-md-1" }
const _hoisted_57 = {
  key: 0,
  class: "col-md-2"
}
const _hoisted_58 = {
  key: 1,
  class: "col-md-2"
}
const _hoisted_59 = {
  class: "card-footer py-5 text-center",
  id: "kt_batch_update_footer"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_batch_update_cancel",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_61 = ["data-kt-indicator"]
const _hoisted_62 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_63 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_64 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h4", {
  class: "text-center text-danger",
  style: {"margin-top":"50vh"}
}, " Batch Calendar exists. You can't edit this batch. ", -1)
const _hoisted_68 = [
  _hoisted_67
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        (_ctx.showBatchDelails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_form, {
                onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
                model: _ctx.formData,
                rules: _ctx.rules,
                ref: "formRef"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.details.batch_number,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.details.batch_number) = $event)),
                            type: "text",
                            name: "sequence_number",
                            class: "form-control form-control-sm text-right",
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.details.sequence_number,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.details.sequence_number) = $event)),
                            type: "text",
                            name: "sequence_number",
                            class: "form-control form-control-sm text-right"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.details.training_location,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.details.training_location) = $event)),
                            type: "text",
                            name: "sequence_number",
                            class: "form-control form-control-sm text-right"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.details.training_capacity,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.details.training_capacity) = $event)),
                            type: "text",
                            name: "sequence_number",
                            class: "form-control form-control-sm text-right",
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_el_form_item, {
                            prop: "date",
                            class: "mb-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.details.start_date,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.details.start_date) = $event)),
                                "value-format": "YYYY-MM-DD",
                                format: "DD-MM-YYYY",
                                type: "date",
                                name: "start_date"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createVNode(_component_el_form_item, {
                            prop: "date",
                            class: "mb-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.details.end_date,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.details.end_date) = $event)),
                                "value-format": "YYYY-MM-DD",
                                format: "DD-MM-YYYY",
                                type: "date",
                                name: "start_date"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.term, (info, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("span", _hoisted_28, "Term: " + _toDisplayString(info.term), 1),
                                    _createElementVNode("span", _hoisted_29, "Day: " + _toDisplayString(info.term_day), 1),
                                    _createElementVNode("span", _hoisted_30, "Session: " + _toDisplayString(info.term_session), 1),
                                    _createElementVNode("span", _hoisted_31, "Hour: " + _toDisplayString(info.term_hour), 1),
                                    _createElementVNode("span", _hoisted_32, [
                                      _createTextVNode("Class Type: "),
                                      (info.class_type == 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Class Work"))
                                        : _createCommentVNode("", true),
                                      (info.class_type == 2)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Internship"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                      _hoisted_37,
                                      _createVNode(_component_el_form_item, {
                                        prop: "date",
                                        class: "mb-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_date_picker, {
                                            modelValue: _ctx.term[index].start_date,
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].start_date) = $event),
                                            "value-format": "YYYY-MM-DD",
                                            format: "DD-MM-YYYY",
                                            type: "date",
                                            style: {"width":"100%"},
                                            name: `term[${index}].start_date`
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                      _hoisted_39,
                                      _createVNode(_component_el_form_item, {
                                        prop: "date",
                                        class: "mb-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_date_picker, {
                                            modelValue: _ctx.term[index].end_date,
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].end_date) = $event),
                                            "value-format": "YYYY-MM-DD",
                                            format: "DD-MM-YYYY",
                                            type: "date",
                                            style: {"width":"100%"},
                                            name: `term[${index}].end_date`
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("table", _hoisted_41, [
                                      _createElementVNode("thead", null, [
                                        _createElementVNode("tr", _hoisted_42, [
                                          _hoisted_43,
                                          _hoisted_44,
                                          _hoisted_45,
                                          _hoisted_46,
                                          _hoisted_47,
                                          (info.class_type == '1')
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_48, " Lead Trainer "))
                                            : _createCommentVNode("", true),
                                          (info.class_type == '1')
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_49, " Associate Trainer "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.term[index].day, (inf, w_i) => {
                                          return (_openBlock(), _createElementBlock("tr", { key: w_i }, [
                                            _createElementVNode("td", _hoisted_50, [
                                              _createVNode(_component_el_select, {
                                                modelValue: _ctx.term[index].day[w_i],
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].day[w_i]) = $event),
                                                class: "form-select-solid",
                                                placeholder: "Select Day",
                                                name: `term[${index}].day[${w_i}]`,
                                                filterable: "",
                                                style: {"width":"100%"},
                                                onChange: ($event: any) => (_ctx.getDay(_ctx.term[index].day[w_i], index, w_i))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_option, {
                                                    label: "Saturday ",
                                                    value: "Saturday"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Saturday")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    label: "Sunday",
                                                    value: "Sunday"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Sunday")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    label: "Monday",
                                                    value: "Monday"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Monday")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    label: "Tuesday ",
                                                    value: "Tuesday"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Tuesday")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    label: "Wednesday",
                                                    value: "Wednesday"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Wednesday")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    label: "Thursday",
                                                    value: "Thursday"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Thursday")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    label: "Friday",
                                                    value: "Friday"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Friday")
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue", "name", "onChange"])
                                            ]),
                                            _createElementVNode("td", _hoisted_51, [
                                              _createVNode(_component_Field, {
                                                class: "form-control form-control-sm text-right",
                                                placeholder: "Select Room",
                                                modelValue: _ctx.term[index].training_room[w_i],
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].training_room[w_i]) = $event),
                                                filterable: "",
                                                name: `term[${index}].training_room[${w_i}]`,
                                                style: {"width":"100%"}
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                            ]),
                                            _createElementVNode("td", _hoisted_52, [
                                              _withDirectives(_createElementVNode("input", {
                                                class: "form-control",
                                                type: "time",
                                                placeholder: "Start time",
                                                name: `term[${index}].start_time[${w_i}]`,
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].start_time[w_i]) = $event),
                                                format: "hh:mm A",
                                                "value-format": "hh:mm A",
                                                style: {"width":"100%"},
                                                onBlur: ($event: any) => (
                                        _ctx.getDuration(
                                          _ctx.term[index].end_time[w_i],
                                          _ctx.term[index].start_time[w_i],
                                          index,
                                          w_i,
                                          info.term_session,
                                          info.term_hour
                                        )
                                      )
                                              }, null, 40, _hoisted_53), [
                                                [_vModelText, _ctx.term[index].start_time[w_i]]
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_54, [
                                              _withDirectives(_createElementVNode("input", {
                                                class: "form-control",
                                                type: "time",
                                                placeholder: "End time",
                                                name: `term[${index}].end_time[${w_i}]`,
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].end_time[w_i]) = $event),
                                                format: "hh:mm A",
                                                "value-format": "hh:mm A",
                                                style: {"width":"100%"},
                                                onBlur: ($event: any) => (
                                        _ctx.getDuration(
                                          _ctx.term[index].end_time[w_i],
                                          _ctx.term[index].start_time[w_i],
                                          index,
                                          w_i,
                                          info.term_session,
                                          info.term_hour
                                        )
                                      )
                                              }, null, 40, _hoisted_55), [
                                                [_vModelText, _ctx.term[index].end_time[w_i]]
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_56, [
                                              _createVNode(_component_Field, {
                                                modelValue: _ctx.term[index].duration_hour[w_i],
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].duration_hour[w_i]) = $event),
                                                type: "text",
                                                name: `term[${index}].duration_hour[${w_i}]`,
                                                class: "form-control form-control-sm text-right",
                                                onChange: ($event: any) => (
                                        _ctx.checkDuration(
                                          _ctx.term[index].end_time[w_i],
                                          _ctx.term[index].start_time[w_i],
                                          index,
                                          w_i,
                                          info.term_session,
                                          info.term_hour
                                        )
                                      )
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onChange"])
                                            ]),
                                            (
                                      info.class_type == '1'
                                    )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_57, [
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _ctx.term[index].lead_trainer[w_i],
                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].lead_trainer[w_i]) = $event),
                                                    class: "form-select-solid",
                                                    placeholder: "Select Org Trainer",
                                                    filterable: "",
                                                    name: `term[${index}].training_room[${w_i}]`,
                                                    style: {"width":"100%"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainerInfo, (info) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: info.id,
                                                          label: info.employee_info.name,
                                                          value: info.id
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(info.employee_info.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (
                                      info.class_type == '1'
                                    )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_58, [
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _ctx.term[index].associate_trainer[w_i],
                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].associate_trainer[w_i]) = $event),
                                                    class: "form-select-solid",
                                                    placeholder: "Select Org Trainer",
                                                    filterable: "",
                                                    name: `term[${index}].training_room[${w_i}]`,
                                                    style: {"width":"100%"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainerInfo, (info) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: info.id,
                                                          label: info.employee_info.name,
                                                          value: info.id
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(info.employee_info.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("button", {
                      "data-kt-indicator": _ctx.load ? 'on' : null,
                      class: "btn btn-lg btn-primary",
                      type: "submit",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit()))
                    }, [
                      (!_ctx.load)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                            _createTextVNode(" Submit "),
                            _createElementVNode("span", _hoisted_63, [
                              _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.load)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                            _createTextVNode(" Please wait... "),
                            _hoisted_65
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_61)
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showBatchAlert)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_68))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ]))
}